import React, { useEffect, useRef, useState, useContext } from 'react';

import { Accordion, Form } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

import Nav from 'react-bootstrap/Nav';
import Tab from 'react-bootstrap/Tab';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import Swal from 'sweetalert2';

import useShopeRegistration from '../../../hooks/useShopRegistration';

import { Box } from '@mui/material';

import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { useOnboarding } from '../../../context/AdminSellerRegistrationOB';
import { SubmitHandler, useForm } from 'react-hook-form';
import useBank from '../../../hooks/useBank';
import useSellerPackage from '../../../hooks/useSellerSelectionPackage';

import PayNowImage from '../../../adminAssets/images/payment/paynow.png';
import DBSImage from '../../../adminAssets/images/payment/dbs.png';

export const PackageTypeEnum = Object.freeze({
    Monthly: 0,
    Yearly: 1
});

export const PaymentType = Object.freeze({
    BankTransfer: 0,
    CreditCard: 1,
    PayNow: 2
});

const schema = yup
    .object({
        packageId: yup.string().required(),
        bankTransferId: yup.string().required(),
        bankaccountname: yup.string(),
        bankaccountnumber: yup.string()
    })
    .required();

const CompanySellerSubsPayment_Summary = () => {
    const navigate = useNavigate();

    const { fetchActiveBank, data: activeBank } = useBank();
    const { fetchPackage, data: sellerPackages } = useSellerPackage();
    const [activeKey, setActiveKey] = useState('0');
    const [selectedValue, setSelectedValue] = useState(null);
    const [selectedBankValue, setSelectedBankValue] = useState(null);
    const { saveStep, saveQris, data, qris, clear } = useOnboarding();

    //console.log(sellerPackages);
    const { sentCustomerShopCreate: subscribeShop } = useShopeRegistration();

    const [isYearly, setIsYearly] = useState(false);

    const DatatoSent = {
        bussinesstype: data.bussinesstype ?? '',
        ownerName: data.ownerName ?? '',
        citizenID: data.citizenID ?? '',
        agreement: data.agreement ?? false,
        email: data.email ?? '',
        shopName: data.shopName ?? '',
        phone: data.phone ?? '',
        phoneCC: data.phone ?? '+62'
    };

    const StaticProductCategory = [
        {
            isActive: true,
            id: 'f37f7e82-b3a3-49b8-9485-dd2ac2ab11c1',
            name: 'Economy Plan',
            description: 'Newly Or Personal start up bussiness',
            descriptionList: [
                'Up to 30 days listing product display',
                'Up to 1 username per 1 shop',
                'Up to 100 products listing per shops',
                'Bussniness Location limit to Local country only',
                'Shop advertise up to local community only'
            ],

            totalUser: 0,
            monthlyPrice: 5,
            yearlyPrice: 60,
            discountedMonthlyPrice: 3,
            discountedYearlyPrice: 45,
            subscriptionType: 1,
            image: null,
            color: null,
            index: 1,
            canDowngrade: false
        },
        {
            isActive: false,
            id: 'f37f7e82-b3a3-49b8-9485-dd2ac2ab11c2',
            name: 'Business Plan',
            description: 'For seller who wants to seriously expand their business',
            descriptionList: [
                'Up to 30 days listing product listing display',
                'Up to 1 username in multiple devices',
                'Up to 300 products listing per shops',
                'Bussniness Location limit up to ASEAN customer',
                'Shop advertise up to up to ASEAN seller & customer'
            ],
            totalUser: 0,
            monthlyPrice: 20,
            yearlyPrice: 240,
            discountedMonthlyPrice: 15,
            discountedYearlyPrice: 180,
            subscriptionType: 2,
            image: null,
            color: null,
            index: 2,
            canDowngrade: false
        },
        {
            isActive: false,
            id: 'f37f7e82-b3a3-49b8-9485-dd2ac2ab11c3',
            name: 'First Class',
            description: 'For seller who wants all the benefits and premium services',
            descriptionList: [
                'Up to 30 days listing product listing display',
                'Up to 1 username in multiple devices',
                'Up to 1K+ items products listing',
                'Bussniness Location limit up to ASEAN customer',
                'Shop advertise up to up to ASEAN seller & customer',
                'Optional for Website development up to 5 basic pages (minimum 2 years contract plan)',
                'Optional dedicated managing on TikTok/IG/FB (minimum 1 year contract plan)'
            ],
            totalUser: 0,
            monthlyPrice: 50,
            yearlyPrice: 50 * 12,
            discountedMonthlyPrice: 40,
            discountedYearlyPrice: 40 * 12,
            subscriptionType: 3,
            image: null,
            color: null,
            index: 3,
            canDowngrade: false
        }
    ];

    const handleRadioClick = (e, value) => {
        e.stopPropagation(); // Crucial: Prevents the click from reaching the accordion toggle
        console.log(value);
        setSelectedValue(value);

        //console.log(value)
    };

    const prevData = data;

    const handleBankClick = (e, value) => {
        setSelectedBankValue(value);
    };

    const inputcheckClass = (field) => `form-check mb-0 custom-circular-checkbox ${errors[field] ? 'is-invalid' : ''}`;

    // This function handles the accordion toggle (optional, can be managed by activeKey alone)
    const handleAccordionToggle = (eventKey) => {
        setActiveKey(eventKey);
    };

    const accordionItems = [
        { eventKey: '0', header: 'Item #1', body: 'Content for item 1.' },
        {
            eventKey: '1',
            header: 'Item #2',
            body: 'Content for item 2.'
        },
        { eventKey: '2', header: 'Item #3', body: 'Content for item 3.' }
    ];

    const onSubmit = async (formData) => {
        // await api.post("/register/complete", data);
        // clear();
        // navigate("/registration-seller-completed");
        // console.log("FORM DATA:", formData);

        // console.log("..data: ");
        // console.log(...data);
        const payload = {
            ...prevData, // onboarding data
            // formData,
            userId: JSON.parse(localStorage.getItem('user')).id,
            packageId: formData.packageId,
            bankTransferId: formData.bankTransferId,
            shippingLatLong:
                data.shippinglatitude !== undefined && data.shippinglongitude !== undefined
                    ? data.shippinglatitude + ',' + data.shippinglongitude
                    : '',
            businessLatLong: data.latitude !== undefined && data.longitude !== undefined ? data.latitude + ',' + data.longitude : '',
            bankAccountName: formData.bankaccountname,
            bankAccountNumber: formData.bankaccountnumber,
            yearEstablish: data.yearEstablished ?? new Date().getFullYear(),
            packageType: isYearly ? PackageTypeEnum.Yearly : PackageTypeEnum.Monthly
        };

        try {
            const result = await subscribeShop(payload);
            console.log(result);
            Swal.fire({
                title: 'Success',
                text: 'Register successfully',
                icon: 'success'
            });
            if (result == 'success!') {
                console.log(result);
                saveQris({
                    qrisImage: selectedBankValue.qris,
                    bankTransferId: formData.bankTransferId
                });

                console.log(qris);
            }

            saveQris({
                qrisImage: selectedBankValue.qris,
                bankTransferId: formData.bankTransferId
            });

            navigate('/admin/seller-subscription-completed');
        } catch (err) {
            //console.log(err);
            Swal.fire({
                title: 'Error',
                text: err,
                icon: 'error'
            });
        }
    };

    const readUserData = () => {
        if (localStorage.getItem('user') == null) {
            navigate('/login');
        }
    };

    useEffect(() => {
        readUserData();
        fetchPackage();
        console.log(sellerPackages);
        fetchActiveBank();
    }, []);

    const {
        register,
        handleSubmit,
        reset,

        setValue,
        formState: { errors }
    } = useForm({
        resolver: yupResolver(schema),
        defaultValues: {
            bankaccountname: data.bankaccountname ?? '',
            bankaccountnumber: data.bankaccountnumber ?? ''
        }
    });

    return (
        <div className="payment_summary text_quicksand">
            <div className="container">
                <div className="card mb-40">
                    <div className="card-body">
                        <div className="row">
                            <div className="col-12 col-md-6 mb-20">
                                <div>
                                    <span className="text_quicksand text-14">Shop Name</span>
                                </div>
                                <div>
                                    <span className="text_quicksand text-14 fw-medium">{data.businessName ?? data.name}</span>
                                </div>
                            </div>
                            <div className="col-12 col-md-6  mb-20">
                                <div>
                                    <span className="text_quicksand text-14">Email</span>
                                </div>
                                <div>
                                    <span className="text_quicksand text-14 fw-medium">{data.email}</span>
                                </div>
                            </div>
                            <div className="col-12 col-md-6 mb-20">
                                <div>
                                    <span className="text_quicksand text-14">Bussiness Type</span>
                                </div>
                                <div>
                                    <span className="text_quicksand text-14 fw-medium">
                                        {data.businessType === 0 ? 'Personal' : 'Company'}
                                    </span>
                                </div>
                            </div>
                            <div className="col-12 col-md-6 mb-20">
                                <div>
                                    <span className="text_quicksand text-14">Phone Number</span>
                                </div>
                                <div>
                                    <span className="text_quicksand text-14 fw-medium">{data.phone}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="title text_quicksand fw-bold text-32 text-black d-flex justify-content-between align-items-center mb-40">
                    <span>Plan</span>

                    <Box
                        onClick={() => setIsYearly(!isYearly)}
                        sx={{
                            position: 'relative',
                            width: 250,
                            height: 36,
                            backgroundColor: '#E8E8E8',
                            borderRadius: '36px',
                            cursor: 'pointer',
                            '&::before': {
                                content: '""',
                                position: 'absolute',
                                width: '124px',
                                height: '100%',
                                backgroundColor: '#970A02',
                                borderRadius: '36px',
                                left: isYearly ? '126px' : '0',
                                transition: '0.3s'
                            }
                        }}
                    >
                        <Box
                            sx={{
                                position: 'relative',
                                zIndex: 1,
                                display: 'flex',
                                height: '100%',
                                alignItems: 'center',
                                textAlign: 'center',
                                fontWeight: 500
                            }}
                        >
                            <Box
                                sx={{
                                    flex: 1,
                                    color: !isYearly ? '#fff' : '#A1A1A1',
                                    fontFamily: 'Quicksand, sans-serif',
                                    fontSize: '16px'
                                }}
                            >
                                Monthly
                            </Box>
                            <Box
                                sx={{
                                    flex: 1,
                                    color: isYearly ? '#fff' : '#A1A1A1',
                                    fontFamily: 'Quicksand, sans-serif',
                                    fontSize: '16px'
                                }}
                            >
                                Yearly
                            </Box>
                        </Box>
                    </Box>
                </div>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="mx-auto mb-70 mt-70" style={{}}>
                        <Accordion defaultActiveKey="0">
                            {StaticProductCategory.map((item, index) => (
                                <>
                                    {!isYearly && item.id === 'f37f7e82-b3a3-49b8-9485-dd2ac2ab11c3' ? null : (
                                        <Accordion.Item
                                            eventKey={String(index)}
                                            className={selectedValue?.index === String(index) ? 'accordion-item-selected' : ''}
                                        >
                                            <Accordion.Header>
                                                <span className="position-relative">
                                                    <Form.Check
                                                        type="radio"
                                                        // id={`radio-`+String(index + 3)}
                                                        // name="plan_selection"
                                                        {...register('packageId')}
                                                        value={String(item.id)}
                                                        checked={selectedValue?.index === String(index)}
                                                        onChange={() => {}} // dummy onChange as actual state update is in onClick
                                                        onClick={(e) =>
                                                            handleRadioClick(e, {
                                                                index: String(index),
                                                                id: item.id,
                                                                price: item.monthlyPrice,
                                                                packageName: item.name
                                                            })
                                                        }
                                                        className="ms-3 custom-circular-checkbox-red"
                                                        // Ensure the label text is clear for accessibility
                                                        aria-label={`Select item ` + String(index)}
                                                    />
                                                    {/* <span className="" style={{width:"16px", height:"16px", backgroundColor:"red", top:"50%", left:"50%", transform:"translate(-50%)"}}></span> */}
                                                </span>

                                                <span className="d-flex justify-content-between align-items-center px-16 w-100">
                                                    <span className="row-cols-1">
                                                        <span className="d-block fw-bold text-18 mb-5">{item.name}</span>
                                                        <span className="d-block text-14" style={{ color: '#666666' }}>
                                                            {item.description}
                                                        </span>
                                                    </span>
                                                    <span className="fw-bold text-18 ">
                                                        Rp {isYearly ? item.yearlyPrice : item.monthlyPrice} / {isYearly ? 'Year' : 'Month'}
                                                    </span>
                                                </span>
                                            </Accordion.Header>
                                            <Accordion.Body className="px-52 pt-0">
                                                <span className="row row-cols-1 row-cols-md-2 w-100 text-14 border-top pt-20">
                                                    {item.descriptionList.map((desc, ind) => (
                                                        <span className="d-flex gap-5 align-items-center mb-10">
                                                            <i class="ph-duotone ph-check-circle" style={{ color: '#299e60' }}></i>
                                                            <span>{desc}</span>
                                                        </span>
                                                    ))}
                                                </span>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                    )}
                                </>
                            ))}
                        </Accordion>
                    </div>

                    <div className="card mb-40">
                        <div className="card-body">
                            <div className="mb-20">
                                <span className="text-20 fw-bold">Payment Details</span>
                            </div>
                            <div>
                                <div className="d-flex justify-content-between mb-10 text-16">
                                    <span className="">
                                        Order Subtotal {selectedValue ? <strong>{selectedValue.packageName + ' Plan'}</strong> : ''}
                                    </span>
                                    <span className="fw-bold">Qty : {isYearly ? 12 : 1} months</span>
                                    <span>
                                        Rp
                                        {selectedValue
                                            ? selectedValue.price
                                                ? isYearly
                                                    ? (selectedValue.price * 12).toFixed(2)
                                                    : selectedValue.price.toFixed(2)
                                                : '0.00'
                                            : '0.00'}
                                    </span>
                                </div>
                                {/* <div className="d-flex justify-content-between  mb-10 text-16 d-none">
                                    <span className="">Delivery Fee</span>
                                    <span>$1000.00</span>
                                </div>
                                <div className="d-flex justify-content-between mb-10 text-16  d-none">
                                    <span className="">Delivery Discount</span>
                                    <span className="text-danger">-$5.00</span>
                                </div> */}
                            </div>
                            <hr />
                            <div className="mb-20">
                                <div className="d-flex justify-content-between mb-10 text-16 fw-bold">
                                    <span className="">Order Subtotal : </span>
                                    <span>
                                        Rp
                                        {selectedValue
                                            ? selectedValue.price
                                                ? isYearly
                                                    ? (selectedValue.price * 12).toFixed(2)
                                                    : selectedValue.price.toFixed(2)
                                                : '0.00'
                                            : '0.00'}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="payment-method mb-80">
                        <div className="text-20 fw-bold mb-40" style={{ color: '#1A1A1A' }}>
                            <span>Payment Method</span>
                        </div>
                        <Tab.Container id="left-tabs-example" className="d-none" defaultActiveKey="home">
                            <Nav variant="pills" className="d-flex align-items-center gap-20 mb-40">
                                <Nav.Item>
                                    <Nav.Link eventKey="banktransfer">Bank Transfer</Nav.Link>
                                </Nav.Item>
                                {/* <Nav.Item>
                                    <Nav.Link eventKey="creditcard">Credit Card</Nav.Link>
                                </Nav.Item>  */}
                                <Nav.Item className="">
                                    <Nav.Link eventKey="paynow">Paynow</Nav.Link>
                                </Nav.Item>
                            </Nav>
                            <Tab.Content>
                                {['banktransfer', 'creditcard', 'paynow'].map((item) => {
                                    const _filteredBanks = activeBank.filter((bank) => {
                                        if (item === 'banktransfer') {
                                            return bank.accountNumber !== '-';
                                        } else if (item === 'paynow') {
                                            return bank.accountNumber === '-';
                                        }
                                        return false;
                                    });

                                    return (
                                        <Tab.Pane eventKey={item}>
                                            <div className="">
                                                <div>
                                                    {_filteredBanks.map((bank, index) => (
                                                        <label className="d-flex align-items-center gap-24 mb-32">
                                                            <span className="position-relative">
                                                                <Form.Check
                                                                    type="radio"
                                                                    id={`bankSelection-` + String(bank + 3)}
                                                                    // name="banks"
                                                                    {...register('bankTransferId')}
                                                                    value={bank.id}
                                                                    onClick={(e) =>
                                                                        handleBankClick(e, {
                                                                            index: String(index),
                                                                            id: bank.id,
                                                                            qris: bank.image
                                                                        })
                                                                    }
                                                                    className="ms-3 custom-circular-checkbox-red"
                                                                    // Ensure the label text is clear for accessibility
                                                                    aria-label={`Select item ` + String(bank + 3)}
                                                                />
                                                            </span>
                                                            <div className="bank-photo-frame flex-center">
                                                                <img
                                                                    src={bank.logo}
                                                                    className="w-100"
                                                                />
                                                            </div>
                                                            <span className="text-16 fw-bold" style={{ color: '#40494C' }}>
                                                                {bank.bankName}
                                                            </span>
                                                        </label>
                                                    ))}
                                                </div>
                                            </div>
                                        </Tab.Pane>
                                    );
                                })}
                            </Tab.Content>
                        </Tab.Container>
                        {/* <div className="bank-content">
                            {activeBank.map(
                                (bank, index) => (
                                    <label className="d-flex align-items-center gap-24 mb-32">
                                        <span className="position-relative">
                                            <Form.Check
                                                type="radio"
                                                id={`bankSelection-` + String(bank + 3)}
                                                // name="banks"
                                                {...register("bankTransferId")}
                                                value={bank.id}
                                                onClick={(e) => handleBankClick(e, { index: String(index), id: bank.id, qris: bank.image })}
                                                className="ms-3 custom-circular-checkbox-red"
                                                // Ensure the label text is clear for accessibility
                                                aria-label={`Select item ` + String(bank + 3)}
                                            />
                                        </span>
                                        <div className="bank-photo-frame flex-center" >
                                            <img src={bank.logo} className="w-100" />
                                        </div>
                                        <span className="text-16 fw-bold" style={{ color: "##40494C" }}>{bank.bankName}</span>
                                    </label>
                                )
                            )}
                        </div> */}
                    </div>

                    <div className="form-group mb-20">
                        <label className="form-label d-flex align-items-center gap-10">
                            <div className="position-relative">
                                <div
                                    className="position-absolute text-white"
                                    style={{ left: '5px', top: '50%', transform: 'translateY(-50%)' }}
                                >
                                    <i class="ph-bold ph-check"></i>
                                </div>
                                <input type="checkbox" className={inputcheckClass('agreement')} {...register('agreement')} />
                            </div>
                            <span className="fw-bold">
                                I aggree with <span className="text-primary">Terms & Conditions</span>.
                            </span>
                        </label>
                    </div>

                    <div className="p-20 text_quicksand mb-40" style={{ backgroundColor: '#F1F1F1' }}>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna
                        aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
                        Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur
                        sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
                    </div>

                    <div className="d-flex justify-content-end">
                        {/* <button className="btn btn_mart_secondary" onClick={() => navigate("/registration-shop-information")}>Previous</button>
                        <button className="btn btn_mart_primary" onClick={() => navigate("/registration-seller-completed")}>Next</button> */}
                        {/* <button className="btn btn_mart_secondary" type="button" onClick={() => navigate("/registration-shop-information")}>Previous</button> */}
                        <button className="btn btn_mart_primary" type="submit">
                            Next
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default CompanySellerSubsPayment_Summary;
